export interface ChipPiecesRow {
  memberId?: string | null;
  memberNo: string;
  displayName?: string;
  nickname?: string;
  seat: string | null;
  tableNo?: number | null;
  seatNo?: number | null;
  chipCounts?: Record<string, number> | null;
  countRevisionId?: string | null;
  rankEligibility?: string;
  finalChips: number;
}
const denomination = (key: string) => /^[1-9]\d*$/.test(key) && Number.isSafeInteger(Number(key));
const count = (value: unknown): value is number =>
  Number.isSafeInteger(value) && Number(value) >= 0;
export function chipPiecesModel(
  rows: ChipPiecesRow[],
  expected?: Record<string, number> | null,
  counted?: Record<string, number> | null,
) {
  const trusted =
    !!expected &&
    Object.keys(expected).length > 0 &&
    Object.entries(expected).every(([k, v]) => denomination(k) && count(v));
  const denominations = [
    ...new Set(
      [
        ...Object.keys(expected ?? {}),
        ...Object.keys(counted ?? {}),
        ...rows.flatMap((row) => Object.keys(row.chipCounts ?? {})),
      ].filter(denomination),
    ),
  ].sort((a, b) => Number(a) - Number(b));
  return {
    denominations,
    rows: rows.map((row) => {
      const entries = Object.entries(row.chipCounts ?? {});
      const hasCounts = entries.length > 0;
      const valid = hasCounts && entries.every(([k, v]) => denomination(k) && count(v));
      const complete =
        valid &&
        trusted &&
        denominations.every((k) => Object.hasOwn(row.chipCounts!, k) && count(row.chipCounts![k]));
      const sum = entries.reduce((n, [, v]) => n + v, 0);
      const weighted = entries.reduce((n, [k, v]) => n + Number(k) * v, 0);
      return {
        row,
        hasCounts,
        complete,
        total: complete && Number.isSafeInteger(sum) ? sum : null,
        chips:
          complete && Number.isSafeInteger(sum) && count(row.finalChips) ? row.finalChips : null,
        inconsistent: complete && (!Number.isSafeInteger(weighted) || weighted !== row.finalChips),
        trusted,
      };
    }),
  };
}
